import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from '../../../common-components/Button/Button';
import { Field, FieldType } from '../../../common-components/Field/Field';
import { strings } from '../../../resources/strings';
import { ContainerBody, Row } from './styles';

export interface IFilterToListCustomersOutput {
    document?: string;
    name?: string;
    email?: string;
    phone?: string;
    creationStartDate?: Date|null;
    creationEndDate?: Date|null;
    lastModificationStartDate?: Date|null;
    lastModificationEndDate?: Date|null;
}

interface IModalFiltersToListCustomersProps {
    appliedFilters?: IFilterToListCustomersOutput;
    close: () => void;
    finish: (values: IFilterToListCustomersOutput) => void;
}

const ModalFiltersToListCustomers: React.FC<IModalFiltersToListCustomersProps> = ({
    appliedFilters,
    close,
    finish
}) => {

    const [ document, setDocument ] = React.useState<string|undefined>(appliedFilters?.document);
    const [ name, setName ] = React.useState<string|undefined>(appliedFilters?.name);
    const [ email, setEmail ] = React.useState<string|undefined>(appliedFilters?.email);
    const [ phone, setPhone ] = React.useState<string|undefined>(appliedFilters?.phone);
    const [ creationStartDate, setCreationStartDate ] = React.useState<Date|null>(appliedFilters?.creationStartDate || null);
    const [ creationEndDate, setCreationEndDate ] = React.useState<Date|null>(appliedFilters?.creationEndDate || null);
    const [ lastModificationStartDate, setLastModificationStartDate ] = React.useState<Date|null>(appliedFilters?.lastModificationStartDate || null);
    const [ lastModificationEndDate, setLastModificationEndDate ] = React.useState<Date|null>(appliedFilters?.lastModificationEndDate || null);

    return (
        <Modal
            show={true}
            onHide={() => close()}
            backdrop="static"
            keyboard={false}
            
        >
            <Modal.Header>
                <Modal.Title>
                    {`${strings.Filter} ${strings.Customers}`}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body style={{maxHeight:'78vh'}}>
                <ContainerBody>
                    <Row>
                        <Field
                            type={FieldType.Text}
                            label={'CPF/CNPJ'}
                            marginRight='5px'
                            value={document}
                            change={(value) => setDocument(value)}
                            replaceEnterCodeByValue={' '}
                            autoFocus={true}
                            marginTop={'0px'}
                            maxLength={20}
                        />
                        <Field
                            type={FieldType.Text}
                            label={strings.Phone}
                            value={phone}
                            change={(value) => setPhone(value)}
                            marginTop={'0px'}
                            maxLength={20}
                        />
                    </Row>
                    <Row>
                        <Field
                            type={FieldType.Text}
                            label={strings.Name}
                            value={name}
                            change={(value) => setName(value)}
                            replaceEnterCodeByValue={' '}
                            marginTop={'0px'}
                        />
                    </Row>
                    <Row>
                        <Field
                            type={FieldType.Text}
                            label={strings.Email}
                            value={email}
                            change={(value) => setEmail(value)}
                            marginTop={'0px'}
                        />
                    </Row>
                    <Row>
                        <Field
                            type={FieldType.DatePicker}
                            label={strings.RegisteredOf}
                            marginRight='5px'
                            value={creationStartDate}
                            change={(value) => setCreationStartDate(value)}
                            marginTop={'0px'}
                        />
                        <Field
                            type={FieldType.DatePicker}
                            label={strings.RegisteredUntil}
                            marginLeft='5px'
                            value={creationEndDate}
                            change={(value) => setCreationEndDate(value)}
                            marginTop={'0px'}
                        />
                    </Row>
                    <Row>
                        <Field
                            type={FieldType.DatePicker}
                            label={strings.ChangedOf}
                            marginRight='5px'
                            value={lastModificationStartDate}
                            change={(value) => setLastModificationStartDate(value)}
                            marginTop={'0px'}
                        />
                        <Field
                            type={FieldType.DatePicker}
                            label={strings.ChangedUntil}
                            marginLeft='5px'
                            value={lastModificationEndDate}
                            change={(value) => setLastModificationEndDate(value)}
                            marginTop={'0px'}
                        />
                    </Row>
                </ContainerBody>
            </Modal.Body>
            <Modal.Footer>
                <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <Button text={strings.Cancel} click={() => close()} marginRight={'10px'} />
                    <Button text={strings.Confirm} click={() => filter()}  marginLeft={'10px'} />
                </div>
            </Modal.Footer>
        </Modal>
    );

    function filter() {
        finish({
            document: document,
            name: name,
            email: email,
            phone: phone,
            creationStartDate: creationStartDate,
            creationEndDate: creationEndDate,
            lastModificationStartDate: lastModificationStartDate,
            lastModificationEndDate: lastModificationEndDate
        });
    }
}

export {ModalFiltersToListCustomers};